<template>
  <v-flex class="toast-message-cnr" offset-lg2 lg8 offset-md2 md8>
    <v-alert
      :type="this.yToastMessage.type"
      :value="this.yToastMessage.value"
      @input="callonclose"
      dismissible
      icon="info_outlined"
      transition
      autoid="tooltip-alert-login"
    >{{ this.yToastMessage.message }}</v-alert>
  </v-flex>
</template>

<script>
export default {
  data() {
    return {}
  },
  props: {},
  created() {
    this.yToastMessage.value = false
  },
  updated() {
    this.showAlert()
  },
  destroyed() {
    this.yToastMessage['value'] = false
    this.yToastMessage['type'] = 'success'
    this.yToastMessage['message'] = ''
  },
  computed: {
    yToastMessage() {
      return this.$store.state.componentStore.yToastMessage
    }
  },
  methods: {
    callonclose() {
      this.yToastMessage['value'] = false
    },
    showAlert() {
      var self = this
      let timer = this.timer
      if (timer) {
        clearTimeout(timer)
      }
      this.timer = setTimeout(() => {
        self.yToastMessage['value'] = false
        self.yToastMessage['type'] = 'success'
        self.yToastMessage['message'] = ''
      }, 3000)
    }
  }
}
</script>
<style lang="scss">
.toast-message-cnr {
  width: 100%;
  position: fixed;
  z-index: 10;
  top: 40px;
  .v-alert.success {
    background-color: #0070c9 !important;
    border-color: #0070c9 !important;
    min-height: 48px;
    padding: 4px;
    font-size: 15px;
  }
  .v-alert.success .v-btn {
    height: 48px;
    width: 48px;
  }
  .v-alert.success .v-icon {
    margin: 0;
    height: 48px;
    width: 48px;
    flex: 0 0 auto;
    align-self: center;
    padding-left: 8px;
  }
  button.v-btn {
    height: 48px;
    width: 48px;
    &:hover:before {
      color: transparent;
    }
  }
}
</style>
